import { TachographDriverStatus } from '@quadminds/shared/tracking-system';

export interface IDriverTachographOutputDto {
    cardId?: string;
    driverStatus?: TachographDriverStatus;
    timestamp?: string;
    dailyDrivingTime?: number;
    weeklyDrivingTime?: number;
    remainingDailyDrivingTime?: number;
    remainingWeeklyDrivingTime?: number;
    biweeklyDrivingTime?: number;
    currentDailyDrivingTime?: number;
    currentWeeklyDrivingTime?: number;
    remainingCurrentDrivingTime?: number;
    remainingShiftDrivingTime?: number;
    cumulativeBreakTime?: number;
    timeLeftUntilDailyRest?: number;
    timeLeftUntilWeeklyRest?: number;
    nextBreakDuration?: number;
    timeUntilNextBreak?: number;
    dailyDrivingTimeExceeds?: number;
}
